"use strict";

exports.__esModule = true;
exports.RenderMeasureTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _DataTable = require("../../Core/DataTable");
var _Device = require("../../Device");
var _PlantStateActivities = require("../../PlantStateActivities");
var _helpers = require("../DataTable/helpers");
var _generateformattedColumns = require("./generateformattedColumns");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var RenderMeasureTable = exports.RenderMeasureTable = function RenderMeasureTable(props) {
  var columns = props.columns,
    data = props.data,
    reload = props.reload;
  var formattedColumns = (0, _generateformattedColumns.generateFormattedColumns)({
    data: data,
    columns: columns
  });
  var devices = _react["default"].useContext(_Device.AllDeviceListContext);
  var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(_react["default"].useContext(_PlantStateActivities.PlantStateActivitiesContext));
  var defaultFilters = (0, _helpers.getDefaultFilters)(formattedColumns, {
    devices: devices,
    plantStateActivities: plantStateActivities
  });
  return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, _extends({}, props, {
    columns: formattedColumns,
    defaultFiltered: defaultFilters,
    reload: reload
  }));
};